import { closeMissionFunctionDef, mobilizeMissionFunctionDef } from '../../../../backend/features/mission/shared';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
export const useMissionActions = () => {
    const { t } = useMissionsTranslation();
    const closeMissionPlatformFn = useTypedPlatformFunction(closeMissionFunctionDef);
    const mobilizeMissionPlatformFn = useTypedPlatformFunction(mobilizeMissionFunctionDef);
    const closeMission = (missionId, missionTypeId) => {
        return closeMissionPlatformFn({
            missionId,
            missionTypeId,
        })
            .then(() => {
            showInfoSnackbar({
                message: t('missions.closed'),
                autoHideDuration: 2000,
            });
        })
            .catch((e) => {
            handleErrorDialog(e);
            throw new Error(e);
        });
    };
    const mobilizeMission = (missionId, missionTypeId) => {
        return mobilizeMissionPlatformFn({
            missionId,
            missionTypeId,
        })
            .then(() => {
            showInfoSnackbar({
                message: t('missions.mobilized'),
                autoHideDuration: 2000,
            });
        })
            .catch(handleErrorDialog);
    };
    return {
        closeMission,
        mobilizeMission,
    };
};
